"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function cityState(city = '', state = '', withComma = true) {
    return [city.trim(), state.trim()].filter((s) => s.length > 0).join(withComma ? ', ' : ' ');
}
exports.default = cityState;
